import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ButtonStyled = styled(Button)`
  height: 3.8rem;
  padding: 0 0.6rem;
  font-weight: 700;
  width: 9rem;
`;
